module.exports = __webpack_public_path__ + "img/license-CC BY-ND.a6598715.png";